if (!customElements.get('bot-cart-discount')) {
  customElements.define(
    'bot-cart-discount',
    class BotCartDiscount extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.bot-discount__input');
        this.error = this.querySelector('.bot-discount__error');

        this.querySelector('.bot-discount__apply').addEventListener('click', () => this.apply());
        this.input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.apply();
        });
        this.querySelectorAll('.bot-discount__remove').forEach((button) => {
          button.addEventListener('click', () => this.remove(button.dataset.code));
        });
      }

      get codes() {
        return (this.dataset.codes || '').split(',').filter(Boolean);
      }

      apply() {
        const code = this.input.value.trim();
        if (!code) {
          this.input.focus();
          return;
        }
        if (this.codes.some((existing) => existing.toLowerCase() === code.toLowerCase())) {
          this.input.value = '';
          return;
        }
        this.update([...this.codes, code]);
      }

      remove(code) {
        this.update(this.codes.filter((existing) => existing !== code));
      }

      update(codes) {
        this.classList.add('is-loading');
        const body = JSON.stringify({ discount: codes.join(',') });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
          })
          .then(() => {
            const cartDrawer = this.closest('cart-drawer');
            if (cartDrawer) {
              cartDrawer.reload();
            } else {
              window.location.reload();
            }
          })
          .catch((e) => {
            console.error(e);
            this.classList.remove('is-loading');
            this.error.textContent = window.cartStrings.error;
            this.error.hidden = false;
          });
      }
    }
  );
}
